import yup from '../../../../helpers/yupInstance';
import type { TFunction } from 'i18next';

export function getAddTrainingActivityTypeFormValidation(t: TFunction) {
  return yup.object({
    nameKey: yup
      .string()
      .max(256, t('formikValidation.maxLength').replace('{0}', '256'))
      .required(t('formikValidation.nameKeyRequired')),
    met: yup
      .number()
      .typeError(t('formikValidation.metRequired'))
      .min(0, t('formikValidation.minValue').replace('{0}', '0'))
      .required(t('formikValidation.metRequired')),
  });
}
